/**
 * 阴影展示大小
 */
export const SHADOW_SIZE = 0.25;

//ppt和海报效果不一致  所以需要调整比例
export const SCALE_WIDTH_RATIO = 2;
export const SCALE_HEIGHT_RATIO = 1.7;
export const SCALE_RATIO = 3;
